import { notify } from "@functions/notification"
import { PlanModule } from "@interfaces/permission_access"
import { RootState } from "@redux/store"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import useUserPlanAccess from "./use-user-plan-access"
import useOrganizationSubscriptionAccess from "@customHooks/fc-payment/use-organization-subscription-access"

/**
 * Check if current user has access to the current module. 
 * If the user doesn't have access, then redirect to private profile section.
 */
const useRestricByPlanType = (module: PlanModule) => {
    const { t } = useTranslation("subscription")
    const [ hasAccess, setHasAccess ] = useState<boolean | null>(null)
    const [ hasLoaded, setHasLoaded ] = useState<boolean>(false)

    const { loggedIn } = useSelector((state: RootState) => state.session)
    const history = useNavigate()
    const { planAccess } = useUserPlanAccess()
    const { organizationSubscription, couponSubscription, hasLoaded: hasLoadedOrgSubs } = useOrganizationSubscriptionAccess()

    useEffect(() => {
        if(!loggedIn) 
        {
            history("/login")
            setHasLoaded(true)
            return
        }

        if(!hasLoadedOrgSubs) return

        if(!planAccess || planAccess.length === 0) return
        const check = planAccess.some(pl => pl === module)
        setHasAccess(check || organizationSubscription || couponSubscription)
        setHasLoaded(true)
    }, [module, planAccess, loggedIn, history, hasLoadedOrgSubs, organizationSubscription, couponSubscription])

    useEffect(() => {
        if(!hasAccess && hasLoaded)
        {
            notify({message: t("noPlan.message"), messageType: "error"})
            history("/practitioner/profile")
        }
    }, [hasAccess, hasLoaded, history, t])

    return { data: hasAccess, hasLoaded, planAccess }
}

export default useRestricByPlanType
